interface Props {
  onLoginClick: () => void;
}

export function GuestBanner({ onLoginClick }: Props) {
  return (
    <div
      className="mb-5 flex items-center gap-3 rounded-xl border px-4 py-3"
      style={{
        background: 'var(--surface)',
        borderColor: 'var(--border)',
        borderTop: '1px solid rgba(244, 114, 182, 0.2)',
      }}
    >
      <span className="shrink-0 text-sm" style={{ color: 'var(--pink)' }}>✦</span>

      <p className="flex-1 text-sm text-white/50">
        Punya akun Tsun?{' '}
        <span className="text-white/70">Login untuk auto-isi data kamu.</span>
      </p>

      <button
        onClick={onLoginClick}
        className="shrink-0 text-xs font-semibold transition-colors hover:text-[#ec4899]"
        style={{ color: 'var(--pink)' }}
      >
        Login →
      </button>
    </div>
  );
}
